const API_URL = "http://localhost:5000/";
export const ESCROW = "0xC5EF2fc1a582Ab32FA1cF8687C8EAC5cA6A82B55";
export const TRANCHE_FACTORY = "0x7A72CdBedBDFD88ecB6d98034Cd0a8B505bED4b5";
export const ERC7540_VAULT_FACTORY = "0xf128A7874ae5c06D28CD4e588EF1Ccec8D626CCF";
export const INVESTMENT_MANAGER = "0xb052af213E5168140F8a338335B59797aF71FcDA";
export const POOL_MANAGER_ADDRESS = "0x77d5dA6E11da05776417565b3fc7bA449310D9b6";
export const USDC = "0x27665c5C954332A115Fad20AA04Ca34bF22802c6";
const RPC_URL = "https://sepolia.base.org";

const baseChainId = "0x14a34"; // Hexadecimal for 8453 (Base Mainnet Chain ID)

const baseChainParams = {
  chainId: "0x14a34",
  chainName: "Base Sepolia",
  nativeCurrency: {
    name: "Base",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: ["https://sepolia.base.org"], // Base mainnet RPC URL
  blockExplorerUrls: ["https://sepolia.basescan.org"],
};

export {
  API_URL,
  RPC_URL,
  baseChainId,
  baseChainParams,
};
